import { AnimatePresence } from 'framer-motion';

import WorkExperienceItem from 'components/EducationWorkExperience/components/WorkExperienceItem';

import { WorkExperience as WorkExperienceType } from 'types/commons';

import styles from '../EducationWorkExperience.module.scss';

interface WorkExperienceProps {
  workExperience: WorkExperienceType;
}

const WorkExperience = ({ workExperience }: WorkExperienceProps) => {
  const workExperienceItemsToShow = workExperience?.records || [];

  return (
    <div className={styles.sectionContentWrapper}>
      <AnimatePresence initial={false}>
        {workExperienceItemsToShow.map((record, index) => (
          <WorkExperienceItem
            key={`work-experience-${index}`}
            record={record}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default WorkExperience;
